import { trackPhotoLoadSuccess, trackPhotoDeleteSuccess, trackPhotoLoadError } from './tracking';

export const initializePhotoUploadTracking = ({ controller, $rootScope, $timeout, $scope, trackingCategory, PhotoUploadService }) => {
  const { ad } = controller;

  controller.previousPhotoCount = ad.photos.length || 0;

  $rootScope.$on('cianUiPhotoUpload:PHOTOS_UPDATED', () => {
    $timeout(() => {
      const currentPhotoCount = ad.photos.length;

      if (currentPhotoCount > controller.previousPhotoCount) {
        const loadedPhotosCount = currentPhotoCount - controller.previousPhotoCount;

        for (let i = 0; i < loadedPhotosCount; i++) {
          trackPhotoLoadSuccess(trackingCategory);
        }
      } else if (currentPhotoCount < controller.previousPhotoCount) {
        trackPhotoDeleteSuccess(trackingCategory);
      }

      controller.previousPhotoCount = ad.photos.length;
    }, 0);
  });

  $scope.$watch(() => controller.photoErrors.length, (newErrorsCount, oldErrorsCount) => {
    if (newErrorsCount > oldErrorsCount) {
      controller.photoErrors.forEach(file => {
        if (!file.isAnalyticsSent) {
          trackPhotoLoadError(file.$error || file.$warning, trackingCategory);
        }

        file.isAnalyticsSent = true;
      });
    }
  });
};
